// CORE
import React, { useContext } from "react";

// THIRD-PARTY LIBRARIES
import { Button, Col, Row } from "react-bootstrap";
import { useFieldArray } from "react-hook-form";
import { FormattedMessage } from "react-intl";

// CONTEXT
import { Context } from "components/Form";

// COMPONENTS
import InputGroupField from "components/FormGroupFields/input-field-group";
import TextareaGroupField from "components/FormGroupFields/textarea-field-group";
import ImageGroupField from "components/FormGroupFields/image-field-group";
import { SelectGroupField } from "components/FormGroupFields/select-field-group";
import FormWrapper from "../form-wrapper";

// ASSETS
import removeImg from "assets/svg/close.svg";

// STYLES
import styles from "./styles/style.module.scss";

const InputsGroup = ({ name, title = name, inputs = [] }) => {
    const { register, control, errors } = useContext(Context);
    const { fields, append, remove } = useFieldArray({
        control,
        name: name,
    });

    const renderInputs = (index) => {
        return inputs?.map((input) => {
            if (input?.locales?.length) {
                return input?.locales?.map((locale) => {
                    if (input?.type === "textarea") {
                        return (
                            <TextareaGroupField
                                key={`${name}.${index}.${input?.name}.${locale}`}
                                parentName={name}
                                index={index}
                                input={input}
                                locale={locale}
                                register={register}
                                errors={errors}
                                type={input?.type}
                                rules={input?.rules}
                                lg={input?.lg}
                            />
                        );
                    }

                    return (
                        <InputGroupField
                            key={` ${name}.${index}.${input?.name}.${locale}`}
                            parentName={name}
                            index={index}
                            input={input}
                            locale={locale}
                            register={register}
                            errors={errors}
                            type={input?.type}
                            rules={input?.rules}
                            lg={input?.lg}
                        />
                    );
                });
            }

            if (input?.type === "textarea") {
                return (
                    <TextareaGroupField
                        key={`${name}.${index}.${input?.name}`}
                        parentName={name}
                        index={index}
                        input={input}
                        register={register}
                        errors={errors}
                        type={input?.type}
                        rules={input?.rules}
                        lg={input?.lg}
                    />
                );
            }

            if (input?.type === "image") {
                return (
                    <ImageGroupField
                        control={control}
                        key={`${name}.${index}.${input?.name}`}
                        parentName={name}
                        index={index}
                        input={input}
                        errors={errors}
                        type={input?.type}
                        rules={input?.rules}
                        lg={input?.lg}
                    />
                );
            }
            if (input?.type === "select") {
                return (
                    <SelectGroupField
                        key={`${name}.${index}.${input?.name}`}
                        parentName={name}
                        index={index}
                        input={input}
                        register={register}
                        errors={errors}
                        type={input?.type}
                        rules={input?.rules}
                        lg={input?.lg}
                        labelName={input?.labelName}
                        valueName={input?.valueName}
                    />
                );
            }

            return (
                <InputGroupField
                    key={`${name}.${index}.${input?.name}`}
                    parentName={name}
                    index={index}
                    input={input}
                    register={register}
                    errors={errors}
                    type={input?.type}
                    rules={input?.rules}
                    lg={input?.lg}
                />
            );
        });
    };

    return (
        <div className={`${styles["inputs-group"]}`}>
            <h5
                className={`title-add-button ${
                    fields?.length === 0 ? "mb-0" : ""
                }`}
            >
                {title && (
                    <span className="side-title">
                        {" "}
                        <FormattedMessage id={title} />{" "}
                    </span>
                )}
                <Button
                    type="button"
                    variant="success"
                    onClick={() => {
                        append();
                    }}
                >
                    <FormattedMessage id="add" />
                </Button>
            </h5>
            <Row className="w-100 m-0">
                {fields.map((item, index) => {
                    return (
                        <Col key={index} xl={12} lg={12} md={12} xs={12}>
                            <FormWrapper>
                                <button
                                    type="button"
                                    onClick={() => remove(index)}
                                    className="remove-icon"
                                >
                                    <img src={removeImg} alt="" />
                                </button>
                                <Row>{renderInputs(index)}</Row>
                            </FormWrapper>
                        </Col>
                    );
                })}
            </Row>
        </div>
    );
};

export default InputsGroup;
